import { Link } from "react-router-dom";
import { plotItems } from "@/mocks/content";

export default function PlotChapterNav({ currentId }: { currentId: string }) {
  const chapters = [...plotItems].sort((a, b) => a.order - b.order);

  return (
    <div className="flex flex-col gap-1">
      {chapters.map((item) => {
        const active = item.id === currentId;
        return (
          <Link
            key={item.id}
            to={`/detail/${item.id}`}
            className={`flex items-center gap-2 rounded-md px-3 py-2 text-sm transition-colors ${
              active
                ? "bg-primary-500 font-medium text-background-50"
                : "text-foreground-700 hover:bg-background-100"
            }`}
          >
            <i className={active ? "ri-bookmark-3-fill" : "ri-bookmark-3-line"}></i>
            <span className="shrink-0 text-xs opacity-80">{item.chapter}</span>
            <span className="truncate">{item.title}</span>
          </Link>
        );
      })}
    </div>
  );
}